import { useTranslation } from "react-i18next";
import Badge from "react-bootstrap/Badge";
import ListGroup from "react-bootstrap/ListGroup";
import { getCharge, getEarn, getTravelerPrice } from "../../Actions";
import { Check, Lock } from "lucide-react";
const Printfiled = ({
  tarif,
  filed,
  filedList,
  onStopSales,
  priceForm,
  config,
  dataIndex,
}) => {
  const { t } = useTranslation();
  switch (filed) {
    case "base_amount":
      return (
        <ListGroup as="ol">
          {" "}
          {filedList.map((f) => (
            <ListGroup.Item
              as="li"
              className="d-flex justify-content-between align-items-start"
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold">{t(f.replace("_price", ""))}</div>
              </div>
              <Badge bg="primary" pill>
                {tarif[f]}
              </Badge>
            </ListGroup.Item>
          ))}
        </ListGroup>
      );
    case "button":
      return (
        <button
          onClick={() => priceForm(dataIndex)}
          className="btn-blue p-2 rounded-0  w-100"
          type="button"
        >
          {t("edit")}
        </button>
      );
    case "is_stop_sales":
      return (
        <div
          className="p-3"
          style={{
            backgroundColor: config.stopSalesColor(tarif[filed]),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => onStopSales(dataIndex)}
        >
          {tarif[filed] === 0 ? (
            <Check color="white" size={15} />
          ) : (
            <Lock color="white" size={15} />
          )}
        </div>
      );

    case "charge":
      return (
        <ListGroup as="ol">
          {" "}
          {filedList.map((f) => (
            <ListGroup.Item
              as="li"
              className="d-flex justify-content-between align-items-start"
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold">{t(f.replace("_price", ""))}</div>
              </div>
              <Badge bg="primary" pill>
                {getCharge(
                  tarif[f],
                  tarif.charge_service,
                  tarif.charge_service_type
                )}
              </Badge>
            </ListGroup.Item>
          ))}
        </ListGroup>
      );

    case "amount_traveler":
      return (
        <ListGroup as="ol">
          {" "}
          {filedList.map((f) => (
            <ListGroup.Item
              as="li"
              className="d-flex justify-content-between align-items-start"
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold">{t(f.replace("_price", ""))}</div>
              </div>
              <Badge bg="primary" pill>
                {getTravelerPrice(
                  tarif[f],
                  tarif.charge_service,
                  tarif.charge_service_type
                )}
              </Badge>
            </ListGroup.Item>
          ))}
        </ListGroup>
      );

    case "you_earn":
      return (
        <ListGroup as="ol">
          {" "}
          {filedList.map((f) => (
            <ListGroup.Item
              as="li"
              className="d-flex justify-content-between align-items-start"
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold">{t(f.replace("_price", ""))}</div>
              </div>
              <Badge bg="primary" pill>
                {getEarn(
                  tarif[f],
                  tarif.charge_service,
                  tarif.charge_service_type
                )}
              </Badge>
            </ListGroup.Item>
          ))}
        </ListGroup>
      );

    default:
      return tarif[filed];
  }
};
export default Printfiled;
